import React, { useEffect, useState } from 'react'
import { TextPrimary, TextSmallBold } from '../../typography'
import { Autocomplete, CircularProgress, Drawer, FormControlLabel, Grid, TextField, Typography } from '@mui/material'
import { useAppSelector } from '../../../app/store/hooks'
import { SearchIcon } from '../../../iconRef/recipePageIcons'
import { RadioGroup } from '@mui/material'
import { Radio } from '@mui/material'
import { ReactComponent as CheckBoxIcon } from "../../../svg/checkBoxIcon.svg";
import { ReactComponent as CheckBoxIconFilled } from "../../../svg/checkBoxIconFilled.svg";
import './filter.module.css';
import FilterButton from './FilterButton'

type FilterType = {
    ingredientFilter: string | any[];
    cuisineFilter: string | any[];
    timeFilter: string;
    mealTypeFilter: string | any[];
};

type FilterProps = {
    localSelected: FilterType;
    setLocalCuisine: (arg: string[]) => void;
    setLocalIngredient: (arg: string[]) => void;
    setLocalTime: (arg: string) => void;
    setLocalMealType: (arg: string[]) => void;
    applySearchFilters: () => Promise<void>;
    applySearchFiltersToLocal: () => Promise<void>;
    drawerOpen: boolean | undefined;
    clearFilter: () => void;
    handleDrawerOpen: (arg: boolean) => void;
    handleDrawerClose: () => void;
    searchFilters: FilterType;
    searchFilterLoading: boolean;
    setIsSearchModalOpen: (arg: boolean) => void;
};

const Filter = ({
    localSelected,
    setLocalCuisine,
    setLocalIngredient,
    setLocalTime,
    setLocalMealType,
    applySearchFilters,
    applySearchFiltersToLocal,
    drawerOpen,
    clearFilter,
    handleDrawerOpen,
    handleDrawerClose,
    searchFilters,
    searchFilterLoading,
    setIsSearchModalOpen
}: FilterProps) => {

    const [filterArray, setFilterArray] = useState<any>(null)
    const ingredientsNameList = useAppSelector((state) => state.search.ingredientsNameList);
    const mealTypeNameList = useAppSelector((state) => state.search.mealTypeList);
    const cuisine = useAppSelector((state) => state.search.cuisineNameList);

    const filterFunc = (type: string) => {
        handleDrawerOpen(true)
        applySearchFiltersToLocal();
        switch (type) {
            case 'Ingredients':
                setFilterArray({
                    placeHolder: 'Search ingredients',
                    selectionType: 'multiple',
                    search: true,
                    autocomplete: true,
                    filterArrayValues: ingredientsNameList,
                    keyName: false,
                    button1: 'Clear All',
                    button2: 'Apply Filters',
                    type: 'ingredient',
                })
                break;
            case 'Cuisines':
                setFilterArray({
                    placeHolder: 'Search cuisines',
                    selectionType: 'multiple',
                    search: true,
                    autocomplete: true,
                    filterArrayValues: cuisine,
                    keyName: false,
                    button1: 'Clear All',
                    button2: 'Apply Filters',
                    type: 'cuisine'
                })

                break;
            case 'Time':
                setFilterArray({
                    selectionType: 'multiple',
                    search: false,
                    autocomplete: false,
                    filterArrayValues: [
                        { label: 'Any' },
                        { label: 'Below 30 mins' },
                        { label: 'More than 30 mins' }
                    ],
                    keyName: 'label',
                    button1: 'Clear',
                    button2: 'Apply',
                    type: 'time'
                })
                break;
            case 'Meal':
                setFilterArray({
                    placeHolder: 'Search cuisines',
                    selectionType: 'multiple',
                    search: false,
                    autocomplete: true,
                    filterArrayValues: mealTypeNameList,
                    keyName: false,
                    button1: 'Clear All',
                    button2: 'Apply Filters',
                    type: 'meal'
                })
                break;
            default:
                throw new Error(`Invalid filter type: ${type}`);
        }
    }

    const menuSelection = async (type: string) => {
       
            await applySearchFilters()
        
        setIsSearchModalOpen(true)

    }

    const handleLocalSelect = (type: string, value: string[]) => {
        if (type === 'ingredient') {
            setLocalIngredient(value)
        }
        else if (type === 'cuisine') {
            setLocalCuisine(value)
        }
        else if (type === 'time') {
            setLocalTime(value[0])
        }
        else if (type === 'meal') {
            setLocalMealType(value)
        }
    }

    const getLocalSelect = (type: string) => {
        if (type === 'ingredient') {
            return localSelected.ingredientFilter
        }
        else if (type === 'cuisine') {
            return localSelected.cuisineFilter
        }
        else if (type === 'meal') {
            return localSelected.mealTypeFilter
        }
        // else if (type === 'time') {
        //     return localSelected.timeFilter
        // }
    }



    const selected = filterArray ? getLocalSelect(filterArray.type) : null;
    return (
        <Grid>
            <Grid>
                <Grid className='filterSection' sx={{ display: 'flex', alignItems: 'center', gap:"6px", overflow: 'scroll' }}>
                    <FilterButton
                        badge={searchFilters.ingredientFilter.length}
                        selected={searchFilters.ingredientFilter?.length > 0}
                        onClick={() => filterFunc('Ingredients')}
                        text="What's&nbsp;in&nbsp;my&nbsp;fridge?" />
                    <FilterButton
                        badge={searchFilters.cuisineFilter.length}
                        selected={searchFilters.cuisineFilter?.length > 0}
                        onClick={() => filterFunc('Cuisines')}
                        text="Cuisines" />
                    <FilterButton
                        badge=''
                        selected={searchFilters.timeFilter !== '' && searchFilters.timeFilter !== 'Any'}
                        onClick={() => filterFunc('Time')}
                        text='Cooking&nbsp;Time' />
                    <FilterButton
                        badge={searchFilters.mealTypeFilter.length}
                        selected={searchFilters.mealTypeFilter.length > 0}
                        onClick={() => filterFunc('Meal')}
                        text="Meal&nbsp;Type" />
                </Grid>
                {filterArray ? <Drawer anchor='bottom' className='filterDrawer' onClose={handleDrawerClose}
                    open={drawerOpen} sx={{ borderRadius: '20px 20px 0 0' }}>
                    <Grid className={filterArray?.search ? "drawer1" : 'drawer2'}
                        sx={{ height: '70vh', backgroundColor: '#FCF8EA', position: 'relative' }}>
                        <Grid sx={{ m: 2, display: 'flex', flexDirection: 'column', mt: filterArray?.search || !filterArray?.autocomplete ? 2 : '-40px' }}>
                            {filterArray?.autocomplete ?
                                <>
                                    <Grid sx={{ position: 'absolute', marginLeft: '12px', marginTop: 1, zIndex: 99 }}>
                                        <SearchIcon />
                                    </Grid>
                                    <Autocomplete
                                        disablePortal
                                        freeSolo
                                        getOptionLabel={(option: any) => (filterArray?.keyName ? option[filterArray?.keyName] : option)}
                                        id="combo-Grid-demo"
                                        limitTags={1}
                                        multiple
                                        onChange={(event, value) => handleLocalSelect(filterArray?.type, value)}
                                        open
                                        options={filterArray?.filterArrayValues}
                                        renderInput={(params) =>
                                            <TextField {...params}
                                                className='searchPage'
                                                placeholder={filterArray?.placeHolder}
                                                sx={{ backgroundColor: '#fff', outline: 0, borderRadius: '10px' }}
                                            />
                                        }
                                        renderOption={(props, option: any, { selected }) => (
                                            <li {...props}>
                                                <>
                                                    <Grid style={{ display: selected ? "block" : "none" }} sx={{ width: 10, height: 23 }}><CheckBoxIconFilled /></Grid>
                                                    <Grid style={{ display: selected ? "none" : "block" }} sx={{ width: 10, height: 23 }}><CheckBoxIcon /></Grid>
                                                </>
                                                <Grid sx={{ flexGrow: 1, fontSize: '15px', ml: 2 }}>{filterArray?.keyName ? option[filterArray?.keyName] : option}</Grid>
                                            </li>
                                        )
                                        }
                                        sx={{ width: '100%' }}
                                        value={selected as Array<string>}
                                    />
                                </> :
                                <Grid sx={{ m: 2, display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
                                    <RadioGroup
                                        aria-labelledby="demo-radio-buttons-group-label"
                                        defaultValue={localSelected.timeFilter}
                                        onChange={(event, value) => handleLocalSelect(filterArray.type, [value])}
                                    >
                                        {filterArray?.filterArrayValues?.map((filterValue: any) => (
                                            <FormControlLabel control={<Radio />} label={<TextPrimary text={filterValue[filterArray?.keyName]} />} value={filterValue[filterArray?.keyName]} />
                                        ))}
                                    </RadioGroup>
                                </Grid>
                            }
                            <Grid sx={{ display: 'flex', justifyContent: 'space-between', position: 'absolute', bottom: 10, zIndex: 20, width: '90%', backgroundColor: '#FCF8EA', pt: 1 }}>
                                {searchFilterLoading ? <Grid sx={{ display: "flex", justifyContent: "center", alignItems: "center", height: "max-content", width: "100%", gap: "8px" }}>
                                    <Typography variant='caption4LightOutfit'>Loading...</Typography>
                                    <CircularProgress color="inherit" size={20} />
                                </Grid> :
                                    <>
                                        <Grid onClick={() => clearFilter()} sx={{ display: "flex", alignItems: "center", justifyContent: 'space-around', textWrap: "nowrap", gap: "8px", p: 2, color: '#FF0000', width: '50%', textAlign: 'center', fontSize: '14px', fontWeight: 400 }}>
                                            {filterArray?.button1}
                                        </Grid>
                                        <Grid onClick={() => menuSelection(filterArray?.type)} sx={{ display: "flex", alignItems: "center", justifyContent: 'space-around', textWrap: "nowrap", gap: "8px", p: 1, color: '#FFF', backgroundColor: '#3B1F8E', width: '50%', textAlign: 'center', borderRadius: '10px', fontSize: '14px', fontWeight: 600 }}>
                                            {filterArray?.button2}
                                        </Grid>
                                    </>
                                }
                            </Grid>
                        </Grid>
                    </Grid>
                </Drawer> : null}
            </Grid>
        </Grid>
    )
}

export default Filter
